module.exports = __webpack_public_path__ + "img/homekv3.c6b6eb28.jpg";